import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

import { ApplicationsPendingComponent } from './components/applications-pending.component';
import { ApplicationsCallbackComponent } from './components/applications-callback.component';
import { ApplicationsResolvedComponent } from './components/applications-resolved.component';
import { ApplicationDetailsComponent } from './components/application-details.component';

@NgModule({
  declarations: [ApplicationsPendingComponent, ApplicationsCallbackComponent, ApplicationsResolvedComponent, ApplicationDetailsComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class ApplicationsModule { }
